const listaMesesTexto = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const letras = '0123456789ABCDEF';
const cores = [
  '#0082c8', '#e6194b', '#3cb44b', '#ffe119', '#f58231',
  '#911eb4', '#46f0f0', '#f032e6', '#d2f53c', '#fabebe',
  '#008080', '#e6beff', '#aa6e28', '#fffac8', '#800000',
  '#aaffc3', '#808000', '#ffd8b1', '#000080', '#808080' ]

export const arrayIsEmpty = (array) => {
    return (array && array.length <= 0);
}

export const getCorAleatoria = (index = 0) => {
    if(index < cores.length - 1) {
        return cores[index];
    } else {
      let cor = '#';
      for (var i = 0; i < 6; i++) {
          cor += letras[Math.floor(Math.random() * 16)];
      }
      return cor;
    }
}

export const getMensagemDeErro = (erro) => {
    if(erro && erro.response && erro.response.data) {
        return erro.response.data.message;
    }
};

export const pad = (n, width, z) => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const stringToArray = (string) => {
    return string ? string.split(",") : null;
}

export const getListaMesesTexto = () => {
    return listaMesesTexto;
}

export const getMesTexto = (mes) => {
    return listaMesesTexto[parseInt(mes) - 1];
}

export const formatarCPF = (cpf) => {
    if(!cpf) {
        return;
    }

    try {
        return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } catch(err) {
        return;
    }
}

export const formatarCNPJ = (cnpj) => {
    if(!cnpj) {
        return;
    }

    try {
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    } catch(err) {
        return;
    }
}

/**
 * Função que retira todos os caracteres especiais de uma string
 * Carecteres que serão removidos: 'ÁÉÍÓÚáéíóúâêîôûàèìòùÇç/.,~!@#$%&_-'
 * @param {string} string - String que será normalizada
 * @return string
 */
export const normalizarString = (string) => {    
    const stringNormalizada = string.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
    return stringNormalizada;
}

export const formatarData = (data) => {
    if(!data) {
        return;
    }

    try {
        return new Date(data).toLocaleString("pt-br");
    } catch(err) {
        return;
    }
}

export const formatarPercentual = (percentual) => {
    if(!percentual) {
        return;
    }

    try {
        return Math.floor(percentual * 100) + "%";
    } catch(err) {
        return;
    }
}

export const formataMoeda = (valorItem, prefixo, SeparadorMilesimo, SeparadorDecimal, limiteMaximo = 15)  => {

    const maxLen = limiteMaximo;
    let valor = valorItem.toString().replace(".","");
    valor = valor.toString().replace(",","");
	let len = valor.length;
	let key = '';
	let i = 0;
	const strCheck = '0123456789';
	let aux = '';
	
	if (strCheck.indexOf(key) === -1) {
		return false;
	} // Chave inválida

	if (len >= maxLen) {
		return false;
	}

	for (i = 0; i < len; i += 1) {
		if ((valor.charAt(i) !== '0') && (valor.charAt(i) !== SeparadorDecimal)) {
			break;
		}
	}
	for (; i < len; i += 1) {
		if (strCheck.indexOf(valor.charAt(i)) !== -1) {
			aux += valor.charAt(i);
		}
	}
	aux += key;
	len = aux.length;
	if (len === 0) {
		valor = '';
	}
	if (len === 1) {
		valor = `0${SeparadorDecimal}0${aux}`;
	}
	if (len === 2) {
		valor = `0${SeparadorDecimal}${aux}`;
	}
	if (len > 2) {
		let aux2 = '';
		let len2 = 0;
		let j = 0;
		for (j = 0, i = len - 3; i >= 0; i -= 1) {
			if (j === 3) {
				aux2 += SeparadorMilesimo;
				j = 0;
			}
			aux2 += aux.charAt(i);
			j += 1;
		}
		valor = '';
		len2 = aux2.length;
		for (i = len2 - 1; i >= 0; i -= 1) {
			valor += aux2.charAt(i);
		}
		valor += SeparadorDecimal + aux.substr(len - 2, len);
	}
	return `${prefixo ? `${prefixo} `:""}${valor}`;
}

export const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
            reject(error);
        }
    })
}

export const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export const convertKeyValueToNumber = (list, keyDefault, key = null) => {
    const array = key ? list.filter(item => item[key]) : list;

    return array.reduce((acc, obj) => (acc + obj[keyDefault]),0);
}




// WEBPACK FOOTER //
// ./src/utils/functions.js